


































































































































import {
  defineComponent,
} from '@nuxtjs/composition-api';

import Slider from "~/components/Palmers/BaseComponents/Slider/Slider.vue";
import SliderItem from "~/components/Palmers/BaseComponents/Slider/SliderItem.vue";
import ProductItem from "~/components/Palmers/Product/Item/ProductItem.vue";
import PictureItem from "~/components/Palmers/BaseComponents/Picture/PictureItem.vue";

export default defineComponent({
  name: 'ShopTheLook',
  components: {
    Slider,
    SliderItem,
    ProductItem,
    PictureItem
  },
  props: {
    shopTheLook: {
      type: Array,
      require: true
    },
    addProductToCart: {
      type: Function,
      require: true
    },
    isProductInCart: {
      type: Function,
      require: true
    },
    canAddProductToCart: {
      type: Function,
      require: true
    },
    addOrRemoveItemFromWishlist: {
      type: Function,
      require: true
    },
    isAuthenticated: {
      type: Boolean,
      require: true
    },
    isProductInWishlist: {
      type: Function,
      require: true
    }
  },
  setup(props){
    console.log(props.shopTheLook)
  },
  data: () => ({
    activeTabIndex: 0,
    progressBarTimeout: 1000,
    progressLoad: 0,
    progress: true
  }),
  mounted() {
    this.$nextTick(() => {
      //@ts-ignore
      if (!this.$device.isMobileOrTablet) {
        this.startProgress();
      }
    });
  },
  methods: {
    startProgress() {
      if (!this.progress) return;

      const percentPerMSecond = 100 / this.progressBarTimeout;

      setTimeout(() => {
        if (!this.progress) return;

        this.progressLoad += percentPerMSecond;

        if (this.progressLoad >= 100) {
          if (this.activeTabIndex >= (this.shopTheLook.length - 1)) {
            this.activeTabIndex = 0;
          } else {
            this.activeTabIndex++;
          }

          this.progressLoad = 0;
        }

        this.startProgress();

      }, 0)
    }
  },
  watch: {
    progress() {
      if (this.progress === true) {
        this.startProgress();
      }
    },
    activeTabIndex() {
      this.progressLoad = 0;
    }
  }
});
